module.exports = __webpack_public_path__ + "img/392.d3e1413b.png";